import "./index.scss";
import { ITag } from "@/common/interface";
import classnames from "classnames";
import React, { useState, useRef, useEffect } from "react";
import SoftBtn from "@/components/common/SoftBtn";
import SoftCell from "@/components/common/SoftCell/RankCell";
import RankWrap from "../lib/RankWrap";
import { IRankItemProps, IRankProps } from "../lib/types";
import { useInViewport } from "ahooks";
import { sendClkLog } from "@/common/selfMonitor";
import { ICategorys } from "@/common/interface";
import { comMonitor, replaceUrlTemplate } from "@/utils/com";
import Link from "@/components/common/Link";
import { OpenType } from "@q/softCore";

interface IItemProps extends IRankItemProps {
  currentIndex: number;
  onMouseEnter: () => void;
  position?: string;
}

/* interface IProps extends  & {position:string} {
  styleType?: "normal" | "";
} */

const Item: React.SFC<IItemProps> = ({
  data,
  data: { href, open_type, open_first, exec, btn_text, category = "1" },
  index,
  currentIndex,
  position,
  onMouseEnter,
}) => {
  let countClassName = "rank__count";

  const configData = {
    href,
    open_type,
    open_first,
    exec,
    btn_text,
    category,
  };

  if (typeof data.rankdiff === "number") {
    countClassName = classnames("rank__count", {
      "rank__count--up": data.rankdiff > 0,
      "rank__count--down": data.rankdiff < 0,
      "rank__count--line": data.rankdiff === 0,
    });
  }
  const nameClassName = classnames(
    "rank__name",
    data.tag && `rank__name--${ITag[data.tag]}`,
  );

  const { clktk } = data;
  const [startTime, setStartTime] = useState(0);
  const onMouseDown = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    setStartTime(Date.now());
  };

  const onMouseUp = (e: React.MouseEvent) => {
    if (Array.isArray(clktk) && clktk.length) {
      const now = Date.now();
      clktk.forEach((url) => {
        const realUrl = replaceUrlTemplate(url, e, startTime, now);
        comMonitor(realUrl);
      });
    }
  };

  const linkConfig = {
    open_type: open_type || OpenType.openDetailInHome,
    exec,
    href,
  };

  const categoryText =
    category && category.length > 0
      ? `${ICategorys[category]}`
      : `${ICategorys[1]}`;

  return (
    <li
      className={classnames("rank__item", {
        active: index === currentIndex,
      })}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
      onMouseEnter={onMouseEnter}
    >
      <Link
        className={classnames("rank__item-link")}
        softId={data.soft_id}
        openType={linkConfig.open_type}
        exec={linkConfig.exec}
        href={linkConfig.href}
        dataText={categoryText}
        ads={data.ads}
        name={data.name}
        position={position}
        category={category}
        style={{ width: "100%" }}
      >
        <span className="rank__index">{index + 1}</span>
        <div className="rank__content">
          <span className={nameClassName}>{data.name}</span>
          <span className={countClassName}>{data.downloadnum}</span>
        </div>
        <SoftCell
          className="soft-cell--sm rank__cell"
          data={data}
          description={data.desc}
          showBtn={false}
          supportLink={true}
          position={position}
        />
        <SoftBtn
          className="rank__btn"
          softId={data.soft_id}
          configData={configData}
          name={data.name}
          position={position}
          comAds={data.clktk}
        />
      </Link>
    </li>
  );
};

const NormalRank: React.FC<IRankProps & { position?: string }> = ({
  title,
  data,
  className = "",
  loading,
  position,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const onMouseEnter = (index: number) => {
    setCurrentIndex(index);
  };

  const nodeRef = useRef<HTMLOListElement>(null);
  const [lock, setLock] = useState(false);
  const [inViewport, ratio] = useInViewport(nodeRef, {
    threshold: [0.1, 0.5, 1],
  });
  // const { soft_id, name } = items.data[index];
  useEffect(() => {
    if (inViewport && !lock && ratio && ratio >= 0.1 && data.length) {
      const monitorIds = data
        .reduce<string>((prev, current, i) => {
          return (
            prev +
            "|" +
            `${current.soft_id}$${current.name}$${
              current.category && current.category.length
                ? ICategorys[current.category]
                : ICategorys[1]
            }`
          );
        }, "")
        .slice(1);
      const params = {
        cid: position, //事件名称组名
        // c : "下载", //事件名称
        // from: (category && category.length) ? ICategorys[category] : '',
        title: monitorIds,
      };
      sendClkLog(params, "track");
      setLock(true);

      const urlItems = data.filter((item) => {
        return item.imptk;
      });

      urlItems.forEach((item) => {
        item.imptk.forEach((img: string) => {
          comMonitor(img);
        });
      });
    }
  }, [inViewport, lock, ratio, data, title, position]);

  const list = data.map((item, index) => (
    <Item
      key={item.soft_id}
      index={index}
      data={item}
      currentIndex={currentIndex}
      onMouseEnter={() => onMouseEnter(index)}
      position={position}
    />
  ));

  const mergedClassName = classnames("rank--normal", className);

  return (
    <RankWrap
      ref={nodeRef}
      title={title}
      className={mergedClassName}
      loading={loading}
    >
      {list}
    </RankWrap>
  );
};

export default NormalRank;
